"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Operations = exports.InternalTicket = exports.UniversalService = exports.StripeHandler = exports.StripeHander = exports.ServiceOrder = exports.QuickbooksConnect = exports.Profile = exports.Pricing = exports.PDFHandler = exports.Order = exports.Notification = exports.Invoice = exports.Hauler = exports.Employee = exports.Equipment = exports.Dumpster = exports.DisposalSite = exports.Customer = exports.Commercial = exports.AuditLog = void 0;
exports.AuditLog = __importStar(require("./audit-trail"));
exports.Commercial = __importStar(require("./commercial"));
exports.Customer = __importStar(require("./customer"));
exports.DisposalSite = __importStar(require("./disposal-site"));
/** @deprecated Use Equipment instead */
exports.Dumpster = __importStar(require("./equipment"));
exports.Equipment = __importStar(require("./equipment"));
exports.Employee = __importStar(require("./employee"));
exports.Hauler = __importStar(require("./hauler"));
exports.Invoice = __importStar(require("./invoice"));
exports.Notification = __importStar(require("./notification"));
exports.Order = __importStar(require("./order"));
exports.PDFHandler = __importStar(require("./pdf-handler"));
exports.Pricing = __importStar(require("./pricing"));
exports.Profile = __importStar(require("./profile"));
exports.QuickbooksConnect = __importStar(require("./quickbooks-connect"));
exports.ServiceOrder = __importStar(require("./service-orders"));
/** @deprecated: Use StripeHandler. */
exports.StripeHander = __importStar(require("./stripe-handler"));
exports.StripeHandler = __importStar(require("./stripe-handler"));
exports.UniversalService = __importStar(require("./service-orders"));
__exportStar(require("./common"), exports);
__exportStar(require("./driver-task"), exports);
exports.InternalTicket = __importStar(require("./internal-tickets"));
exports.Operations = __importStar(require("./operations/operations"));
//# sourceMappingURL=index.js.map